import { RootState } from '../../redux/reducers';
import { AppState } from './reducer';

export const selectAppState = (state: RootState): AppState => state.app;
